const messages = {
  en: {
    action: {
      save: 'Save',
      create: 'Create',
      cancel: 'Cancel',
      copy: 'Copy',
      delete: 'Delete',
      next: 'Next',
      previous: 'Previous'
    },
    address: {
      line1: 'Address',
      line2: 'Appartment',
      city: 'City',
      country: 'Country',
      state: 'Province / State',
      postalCode: 'Postal code / Zip code',
      phone: 'Phone number'
    }
  },
  fr: {
    action: {
      save: 'Sauvegarder',
      create: 'Créer',
      cancel: 'Annuler',
      copy: 'Copier',
      delete: 'Supprimer',
      next: 'Suivant',
      previous: 'Précédent'
    },
    address: {
      line1: 'Adresse',
      line2: 'Appartement',
      city: 'Ville',
      country: 'Pays',
      state: 'Province',
      postalCode: 'Code postal',
      phone: 'Numéro de téléphone'
    }
  }
}
export default messages
